<template>
  <div id="app">
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/stations">Stations</router-link> |
      <router-link to="/workout">Workout</router-link> |
      <router-link to="/settings">Settings</router-link>
    </div>
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    this.$storage.load();
  }
};
</script>

<style lang="scss">
@import "styles/main";
</style>
